export const BOT_CREATE_INTENT_KEY = "pingup-ads-bot-create-intent";
export const SIGNUP_STARTED_AT_KEY = "pingup-ads-signup-started-at";

export const trackEvent = (event) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event });
};

export const trackSignupIfNew = (user) => {
  const startedAt = Number(sessionStorage.getItem(SIGNUP_STARTED_AT_KEY));
  sessionStorage.removeItem(SIGNUP_STARTED_AT_KEY);

  const createdAt = new Date(user?.createdAt).getTime();
  if (startedAt && Number.isFinite(createdAt) && createdAt >= startedAt - 60_000) {
    trackEvent("bot_ai_signup");
  }
};

export const trackBotCreatedFromLanding = () => {
  if (!sessionStorage.getItem(BOT_CREATE_INTENT_KEY)) return;
  sessionStorage.removeItem(BOT_CREATE_INTENT_KEY);
  trackEvent("bot_ai_created");
};